
// First, inject the CSS
const styleElement = document.createElement('style');
styleElement.textContent = `
  @media (min-width: 768px) {
    .prive-widget {
        flex-direction: row-reverse !important;
        gap: 12px !important;
    }
  }
   .prive-widget {
      font-family: "Avenir Next", 'sens-serif' !important;
    }

  .prive_type_box  {
    min-width: 180px !important;
    border: 1px solid #78868E !important;
    cursor: pointer !important;
    padding: 8px 15px 15px 15px !important;
    border-radius: 10px !important;
  }

  .prive_type_box_active {
    border: 2px solid #DEA39C !important;
  }

  .prive_label {
    margin-bottom: 0px !important;
  }

  .prive_label_title {
    margin: 0 !important;
    line-height: 1.25 !important;
    font-size: 15px !important;
    font-weight: 600 !important;
    color: #525659 !important;
  }

  .price-container {
     margin: 4px 0 0 0  !important;
    line-height: 1.25  !important;
    font-size: 16px  !important;
    font-weight: 500  !important;
    color: #525659  !important;
  }

  .prive_input_radio {
    visibility: hidden !important;
  }

  .prive_select {
    margin-bottom: 12px !important;
    color: #53565A !important;
    font-size: 14px !important;
  }

  .subscription-compare-price {
     margin: 4px 0 0 7px  !important;
    line-height: 1.25  !important;
    font-size: 16px  !important;
    font-weight: 500  !important;
    color: #525659  !important;
  }

  .prive-onetime-copy > ul,
  .sub-option-copy > ul {
    margin: 10px 0 0 0;
    padding-left: 15px;
    line-height: 16px;
    letter-spacing: 0;
    color: #53565A;
  }


  .prive-onetime-copy > ul > li,
  .sub-option-copy > ul > li {
    font-size: 14px;
    line-height: 18px;
  }

   .prive-onetime-copy > ul > li::marker,
   .sub-option-copy > ul > li::marker {
       font-size: 10px;
   }

`;

document.head.appendChild(styleElement);

// Functions
function applyCopy(retryCount = 0) {
    const maxRetries = 10;
    const oneTimeElement = document.querySelector('#one');

    if (oneTimeElement && !document.querySelector('.prive-onetime-copy')) {
        const oneTimeDiv = document.createElement('div');
        oneTimeDiv.className = 'prive-onetime-copy';
        oneTimeDiv.innerHTML = `<ul>
        <li>$5 flat rate shipping</li>
        </ul>`;
        oneTimeElement.appendChild(oneTimeDiv);
    } else if (retryCount < maxRetries) {
        setTimeout(() => applyCopy(retryCount + 1), 300);
    }
}

function makeBoxesClickable() {
  // Get all boxes
  const boxes = document.querySelectorAll('.prive_type_box');
  
  boxes.forEach(box => {
    // Remove existing event listeners before adding new ones to prevent duplicates
    box.removeEventListener('click', handleBoxClick);
    box.addEventListener('click', handleBoxClick);
  });
}

// Separate the click handler function for better maintainability
function handleBoxClick(e) {
  // Expanded list of elements to ignore
  if (
    e.target.tagName === 'SELECT' || 
    e.target.tagName === 'OPTION' ||
    e.target.tagName === 'INPUT' ||  // Added to prevent double-triggering
    e.target.closest('.prive_select') ||
    e.target.closest('.prive_info_container') // Added to prevent clicks on info tooltips
  ) {
    return;
  }

  // Find the radio input within this box
  const radio = this.querySelector('input[type="radio"]');
  if (radio && !radio.checked) { // Only trigger if not already checked
    // Trigger the click on the radio input
    radio.click();
    
    // Add active class to clicked box and remove from others
    document.querySelectorAll('.prive_type_box').forEach(b => {
      b.classList.remove('prive_type_box_active');
    });
    this.classList.add('prive_type_box_active');
  }
}

// Remove colon from labels and move prices to new line
function customizeLabels() {
  try {
    // Remove colons
    const labels = document.querySelectorAll('.prive_label_title');
    labels.forEach(label => {
      if (label && label.textContent) {
        label.textContent = label.textContent.replace(':', '');
        label.style.width = '100%'; // Changed from width property to style.width
      }
    });

    // Remove checkmarks
    const checkmarks = document.querySelectorAll('.prive_checkmark');
    checkmarks.forEach(checkmark => {
      if (checkmark && checkmark.parentNode) {
        checkmark.remove();
      }
    });

    // Move price spans to new line
    const priceSpans = document.querySelectorAll('[id^="subprice-"], [id^="oneprice-"]');
    priceSpans.forEach(span => {
      if (span && span.parentNode && !span.parentNode.classList.contains('price-container')) {
        const priceDiv = document.createElement('div');
        priceDiv.classList.add('price-container');
        priceDiv.style.marginTop = '8px';
        
        span.parentNode.insertBefore(priceDiv, span);
        priceDiv.appendChild(span);
      }
    });

    makeBoxesClickable();
    compareAndShowPrices();
     applyCopy();
  } catch (error) {
    console.error('Error in customizeLabels:', error);
  }
}

function compareAndShowPrices() {
    // Get both price elements
    const onePriceElement = document.querySelector('[id^="oneprice-"]');
    const subPriceElement = document.querySelector('[id^="subprice-"]');
    const newSubPriceSpan = document.querySelector('[id^="newsubprice-"]');
    
    if (onePriceElement && subPriceElement && newSubPriceSpan) {
        // Get price values and convert to numbers
        const onePrice = parseFloat(onePriceElement.textContent.replace(/[^0-9.]/g, ''));
        const subPrice = parseFloat(subPriceElement.textContent.replace(/[^0-9.]/g, ''));
        
        // Update the elements
        // First show the discounted price
        subPriceElement.textContent = `$${subPrice.toFixed(2)}`;
        subPriceElement.style.textDecoration = 'none';
        subPriceElement.style.opacity = '1';
        subPriceElement.style.marginRight = '6px';
        subPriceElement.style.color = '#D5908C';
        
        // Then show original price struck through
        newSubPriceSpan.style.display = 'inline-block';
        newSubPriceSpan.style.textDecoration = 'line-through';
        newSubPriceSpan.textContent = `${onePrice.toFixed(2)}`;

        newSubPriceSpan.classList.add('subscription-compare-price');
    }

}

// Ensure the script runs after DOM is fully loaded
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', customizeLabels);
} else {
  customizeLabels();
  compareAndShowPrices();
  applyCopy();
}

// Run when subscription type changes
document.querySelectorAll('input[name^="type-"]').forEach(radio => {
    radio.addEventListener('change', () => setTimeout(compareAndShowPrices, 100));
});

// Run when selling plan changes - with null check
const sellingPlanSelect = document.querySelector('select[id^="sub-selling-plan-"]');
if (sellingPlanSelect) {
    sellingPlanSelect.addEventListener('change', () => {
        setTimeout(compareAndShowPrices, 100);
    });
}

// Run when variant changes (if your theme uses this event)
document.addEventListener('variant:change', compareAndShowPrices);


// Run when Prive widget updates its status
document.addEventListener('prive-update-status', customizeLabels);


// Replace the gift position.
document.addEventListener('prive-done', () => {
    const priveWidget = document.querySelector('.prive-widget');
    if (priveWidget) {
        const widgetContainer = priveWidget.closest('form[action^="/cart/add"]');
        
        if (widgetContainer) {
            // Find existing gift section
            const existingGiftSection = document.querySelector('.gift_container');
            
            if (existingGiftSection) {
                // Clone the existing gift section
                const clonedGiftSection = existingGiftSection.cloneNode(true);
                
                // Remove the original
                existingGiftSection.remove();
                
                // Insert the clone after the prive-widget but before the next sibling
                const nextSibling = priveWidget.nextElementSibling;
                widgetContainer.insertBefore(clonedGiftSection, nextSibling);
                
                // Reattach event listeners to the cloned element
                const giftCheckbox = clonedGiftSection.querySelector('#gift-checkbox');
                const giftForm = clonedGiftSection.querySelector('#gift-form');
                
                if (giftCheckbox && giftForm) {
                    giftCheckbox.addEventListener('change', function() {
                        giftForm.style.display = this.checked ? '' : 'none';
                        
                        // Reset form values when unchecked
                        if (!this.checked) {
                            const inputs = giftForm.querySelectorAll('input, textarea, select');
                            inputs.forEach(input => input.value = '');
                        }
                    });
                }
            }
        }
    }
});

